(function () {
  'use strict';

  angular
    .module('services.cart', [])

    /* @ngInject */
    .factory('CartService', ["$http", "$q", "$location", "$timeout", "AppService", "RoutesService", "HttpService", "toastr", function ($http, $q, $location, $timeout, AppService, RoutesService, HttpService, toastr) {
      var _this = this;
      var commentCanceler = $q.defer();
      var giftCanceler = $q.defer();
      this.update = function (ctrl, data, noevent) {
        ctrl.cart = data.Cart;
        AppService.updateParams(data, noevent);
        var count = 0;
        
        _.each(ctrl.cart.Products, function (line) {
          count += line.Quantity;
        });
        ctrl.count = count;

        ctrl.isLogged = data.IsLogged;
        ctrl.hasCart = data.HasCart;

        if (ctrl.hasCart) {
          if (ctrl.cart.Shipping) {
            ctrl.cart.Shipping.imgSrc = '/img/shipping/' + _.camelCase(ctrl.cart.Shipping.Key) + '.png';
            ctrl.cart.Shipping.imgSrcSm = '/img/shipping/' + _.camelCase(ctrl.cart.Shipping.Key) + '_small.png';
          }
          ctrl.cart.ActionsCo = [];
          ctrl.cart.ProduitOffert = {
            Products: []
          };
          _.each(data.Cart.TradeActions, function (value) {
            switch (value.TradeActionKey) {
            case 'PortOffert':
              ctrl.cart.PortOffert = true;
              ctrl.cart.PortOffertPrix = value.TTCPrice === 0 ? null : value;
              break;
            case 'ProduitOffert':
              ctrl.cart.ProduitOffert.Products.push(value);
              break;
            default:
              ctrl.cart.ActionsCo.push(value);
            }
          });

          if (ctrl.cart.LoyaltyCoupon) {
            ctrl.cart.LoyaltyCoupon.AmountLoyaltyCouponValue = ctrl.cart.LoyaltyCoupon.AmountLoyaltyCoupon * -1;
          }

          ctrl.Visitor = data.Visitor;

          // Delegation
          ctrl.Delegation = data.Delegation;
          // End Delegation
          ctrl.cart.showTTCPrice = data.Visitor.CardType.ShowTTCPrice;

          if (ctrl.step === 5) {
            if (ctrl.cart.RestToPay > 0 && !ctrl.payment) {
              var _routes = RoutesService.get();
              $location.path(_routes.CartPayment.url);
            }
          }
        }
      };
      this.toggleCart =  function (ctrl) {
        if (!ctrl.showCart) {
          ctrl.showCartProducts = true;
          $timeout(function () {
            ctrl.showCart = true;
          }, 100);
        } else {
          ctrl.showCart = false;
          $timeout(function () {
            ctrl.showCartProducts = false;
          }, 350);
        }
        var time = new Date().getTime();
        var inter = setInterval(function () {
          $(window).trigger('scroll');
          var ntime = new Date().getTime();
          if (ntime > time + 700) {
            clearInterval(inter);
          }
        }, 50);
      };
      this.toggleUpdate =  function (ctrl, model) {
        ctrl[model] = !ctrl[model];
        var time = new Date().getTime();
        var inter = setInterval(function () {
          $(window).trigger('scroll');
          var ntime = new Date().getTime();
          if (ntime > time + 700) {
            clearInterval(inter);
          }
        }, 50);
      };
      this.submitCode =  function (ctrl) {
        ctrl.codeLoading = true;
        HttpService.post({
          url: '/Cart/UsePromoCode',
          data: {
            PromoCode: String(ctrl.formCode.data.code)
          }
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                ctrl.formCode.data.code = null;
                ctrl.openCode = false;
                _this.update(ctrl, response.results);
                toastr.success('', translate.messages.CodeOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              } else {
                var title;
                var message = '';
                if (response.status.Message.indexOf('identification') !== -1) {
                  title = translate.messages.CodePersonal;
                } else if (response.status.Message.indexOf('a été entièrement utilisé') !== -1) {
                  title = translate.messages.CodeAlreadyUsed;
                } else {
                  switch (response.status.Message) {
                  case 'Ce code est Invalide.':
                    title = translate.messages.CodeInvalid;
                    break;
                  case 'Ce code promo a déjà été utilisé':
                    title = translate.messages.CodeAlreadyUsed;
                    break;
                  default:
                    title = translate.errors.ErrorHasOccurred;
                    message = translate.errors.TryLater;
                  }
                }

                toastr.warning(message, title, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.codeLoading = false;
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.cancelCode =  function (ctrl, code) {
        ctrl.cancelCodeLoading = true;
        HttpService.post({
          url: '/Cart/RemovePromoCode',
          data: {
            PromoCode: code
          }
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                _this.update(ctrl, response.results);
                toastr.success('', translate.messages.CancelCodeOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.cancelCodeLoading = false;
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.addLoyaltyPoint = function (ctrl) {
        ctrl.loyaltyLoading = true;
        HttpService.post({
          url: '/Cart/UseLoyaltyPoint'
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                _this.update(ctrl, response.results);
                toastr.success('', translate.messages.AddCouponOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.loyaltyLoading = false;
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.cancelLoyaltyPoint = function (ctrl) {
        ctrl.cancelLoyaltyLoading = true;
        HttpService.post({
          url: '/Cart/RemoveLoyaltyPoint'
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                _this.update(ctrl, response.results);
                toastr.success('', translate.messages.CancelCouponOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.cancelLoyaltyLoading = false;
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.useCredit = function (ctrl, id) {
        ctrl.creditsLoading = true;
        HttpService.post({
          url: '/Cart/Credit/Use',
          data: {
            IDCredit: id
          }
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                _this.update(ctrl, response.results);
                toastr.success('', translate.messages.AddCreditOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.creditsLoading = false;
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.cancelCredit = function (ctrl, id) {
        ctrl.cancelCreditLoading = true;
        HttpService.post({
          url: '/Cart/Credit/Cancel',
          data: {
            IDCredit: id
          }
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                _this.update(ctrl, response.results);
                toastr.success('', translate.messages.CancelCreditOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.cancelCreditLoading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.cancelGiftCard =  function (ctrl, code) {
        ctrl.cancelGiftCardLoading = true;
        HttpService.post({
          url: '/Cart/RemoveGiftCard',
          data: {
            PromoCode: code
          }
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                _this.update(ctrl, response.results);
                toastr.success('', translate.messages.CancelCodeOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.cancelGiftCardLoading = false;
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.saveComment = function (comment) {
        commentCanceler.resolve('cancel');
        commentCanceler = $q.defer();
        return $http({
          method: 'POST',
          url: '/Cart/SetComment',
          headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'jsonHttpRequest'
          },
          data: {
            Comment: comment
          },
          timeout: commentCanceler.promise
        })
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.saveGift = function (value, comment) {
        giftCanceler.resolve('cancel');
        giftCanceler = $q.defer();
        return $http({
          method: 'POST',
          url: '/Cart/SetIsGift',
          headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'jsonHttpRequest'
          },
          data: {
            IsGift: value,
            GiftComment: comment
          },
          timeout: giftCanceler.promise
        })
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.getProduct =  function (url) {
        return HttpService.get({
          url: url,
          cache: true
        })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.stepsCartCtrl = null;
      this.stepLogHide = null;
      this.setStepsCartCtrl = function (ctrl) {
        _this.stepsCartCtrl = ctrl;
      };
      this.updateStepsCart = function (ctrl) {
        if (_this.stepLogHide === null) {
          _this.stepLogHide = ctrl.isLogged ? true : false;
        }
        _this.stepsCartCtrl.steps[1].hide = _this.stepLogHide;

        var hide = true;
        _.each(ctrl.cart.Products, function (line) {
          if (!line.Product.IsNumeric) {
            hide = false;
            return false;
          }
        });
        ctrl.isNumericCart = hide;
        _this.stepsCartCtrl.steps[2].hide = hide;

        if (ctrl.step !== 4) {
          _this.stepsCartCtrl.steps[3].hide = ctrl.cart.RestToPay === 0 ? true : false;
        }
        _this.stepsCartCtrl.update(ctrl.step);
      };

      return {
        update: this.update,
        toggleCart: this.toggleCart,
        toggleUpdate: this.toggleUpdate,
        submitCode: this.submitCode,
        cancelCode: this.cancelCode,
        addLoyaltyPoint: this.addLoyaltyPoint,
        cancelLoyaltyPoint: this.cancelLoyaltyPoint,
        useCredit: this.useCredit,
        cancelCredit: this.cancelCredit,
        cancelGiftCard: this.cancelGiftCard,
        saveComment: this.saveComment,
        saveGift: this.saveGift,
        getProduct: this.getProduct,
        setStepsCartCtrl: this.setStepsCartCtrl,
        updateStepsCart: this.updateStepsCart
      };
    }])

    /* @ngInject */
    .factory('ShippingCacheService', ["$cacheFactory", function ($cacheFactory) {
      var cache = $cacheFactory('shippingCache');
      return {
        set: function (key, obj) {
          cache.put(key, obj);
        },
        get: function (key) {
          return cache.get(key);
        }
      };
    }])

    /* @ngInject */
    .factory('ShippingService', ["HttpService", "$http", "$q", "ShippingCacheService", function (HttpService, $http, $q, ShippingCacheService) {
      var canceler = $q.defer();
      return {
        getList: function () {
          return HttpService.get({
            url: '/Shipping/List',
            cache: false
          })
          .then(function (response) {
            return response;
          })
          .catch(function (error) {
            console.error(error);
          });
        },
        getPickUpPoints: function (key, gps) {

          canceler.resolve('cancel');
          canceler = $q.defer();

          return $http({
            method: 'POST',
            url: '/Shipping/PickUpPoint',
            headers: {
              'Content-type': 'application/json',
              'X-Requested-With': 'jsonHttpRequest'
            },
            data: {
              key: key,
              shippingCoordinate: gps
            },
            timeout: canceler.promise
          })
          .then(function (response) {
            if (response.data.status === 'OK') {
              ShippingCacheService.set(key + '|' + gps.Latitude + '|' + gps.Longitude, response.data.results);
              return response.data.results;
            }
          })
          .catch(function (error) {
            console.error(error);
          });

        },
        cancelGetPickUpPoints: function () {
          if (canceler && canceler.resolve) {
            canceler.resolve('cancel');
          }
        },
        selectShipping: function (id, pickup) {
          return HttpService.post({
            url: '/Shipping/Select',
            data: {
              idShippingGridValue: id,
              idPickUpPoint: pickup
            }
          })
          .then(function (response) {
            return response;
          })
          .catch(function (error) {
            console.error(error);
          });
        }
      };
    }])

    /* @ngInject */
    .factory('PaymentService', ["HttpService", function (HttpService) {
      return {
        getList: function () {
          return HttpService.get({
            url: '/Payment/List',
            cache: false
          })
          .then(function (response) {
            return response;
          })
          .catch(function (error) {
            console.error(error);
          });
        },
        selectPayment: function (item) {
          return HttpService.post({
            url: '/Payment/Select',
            data: {
              paymentMethod: {
                IDPaymentMethod: item.IDPaymentMethod,
                Key: item.Key,
                Designation: item.Designation,
                Description: item.Description,
                Selected: item.Selected
              }
            }
          })
          .then(function (response) {
            return response;
          })
          .catch(function (error) {
            console.error(error);
          });
        }
      };
    }]);

})();
